let resumeData = {
  imagebaseurl: "",
  name: "Amit Dimri",
  role: "Full Stack Developer",
  linkedinId: "dimriamit",
  skypeid: "Your skypeid",
  roleDescription: "",
  socialLinks: [
    {
      name: "resume",
      url: "https://docs.google.com/document/d/1jnljatlEUgj6-djnmtHESS26zTLYWnOcoOffC6KCDWw/edit?usp=sharing",
      className: "fa fa-file fa-solid",
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/dimriamit",
      className: "fa fa-linkedin",
    },
    {
      name: "github",
      url: "https://github.com/amitad16",
      className: "fa fa-github",
    },
    {
      name: "medium",
      url: "https://medium.com/@amitad16jan",
      className: "fa fa-clipboard",
    },
    {
      name: "twitter",
      url: "https://twitter.com/dimriamit98",
      className: "fa fa-twitter",
    },
  ],
  contact: [
    {
      name: "email",
      value: "dimriamit98@gmail.com",
      className: "fa fa-solid fa-envelope",
    },
    // {
    //   name: "phone",
    //   value: "+91-8394023734",
    //   className: "fa fa-solid fa-phone",
    // },
  ],
  aboutme:
    "Currently working as a FullStack developer • Aiming for startups • Building end to end product • Creativity in heart • Logical approach to situations.",
  address: "India",
  website: "https://amitad16.github.io",
  education: [
    {
      UniversityName: "DIT University",
      specialization: "Computer Science",
      MonthOfPassing: "",
      YearOfPassing: "2019",
      Achievements: "",
    },
  ],
  work: [
    {
      CompanyName: "Drafteq",
      specialization: "FullStack Developer",
      MonthOfLeaving: "Jan",
      YearOfLeaving: "2021",
      Achievements: "Some Achievements",
    },
    {
      CompanyName: "Drafteq",
      specialization: "React Intern",
      MonthOfLeaving: "Dec",
      YearOfLeaving: "2019",
      Achievements: "Some Achievements",
    },
  ],
  skillsDescription: "Your skills here",
  skills: [
    {
      skillname: "Javascript",
    },
    {
      skillname: "React",
    },
    {
      skillname: "Nextjs",
    },
    {
      skillname: "Nodejs",
    },
    {
      skillname: "MongoDB",
    },
  ],
  portfolio: [
    {
      id: "1",
      name: "Surveyed - npm package",
      link: "https://www.npmjs.com/package/surveyed",
      description: <div>hi</div>,
      imgurl: "images/portfolio/coffee.jpg",
    },
    {
      id: "2",
      name: "Surveyed - npm package",
      link: "https://www.npmjs.com/package/surveyed",
      description: <div>hi</div>,
      imgurl: "images/portfolio/coffee.jpg",
    },
    {
      id: "3",
      name: "Surveyed - npm package",
      link: "https://www.npmjs.com/package/surveyed",
      description: <div>hi</div>,
      imgurl: "images/portfolio/coffee.jpg",
    },
  ],
  testimonials: [
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
    {
      description: "This is a sample testimonial",
      name: "Some technical guy",
    },
  ],
};

export default resumeData;
